/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum BRAND {
	INTRO_VIDEO_URL = "https://www.youtube.com/watch?v=Z3IHfkPub9E",
	DOCUMENTATION_URL = "https://docs.adapptio.com/",
	TUTORIALS_URL = "https://docs.adapptio.com/working-with-adapptio/tutorials",
	REFERENCE_GUIDE_URL = "#referenceGuide",
	FORUM_URL = "https://forum.adapptio.com/",
	PLAYGROUND_URL = "https://editor-playground.adapptio.app/"
}
